<p translate>Please choose which form to use:</p>
@if (areFormsLoading) {
    <sb-loader></sb-loader>
} @else {
    <div class="forms-wrapper">
        @for (form of forms; track form) {
            <div class="department-block truncate" (click)="formSelected.next(form)">
                @if (form.logoLink) {
                    <img class="form-logo" [src]="form.logoLink" alt="logo" />
                } @else {
                    <sb-inline-svg class="icon" aria-label="Team" [url]="'/sb-tools/theme/images/icons/team.svg'">
                    </sb-inline-svg>
                }
                <span class="form-title">{{ form.name }}</span>
                @if (form.description) {
                    <p class="form-description">{{ form.description }}</p>
                }
            </div>
        }
    </div>
}
